var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 13.125V8.125C9.375 7.78005 9.09495 7.5 8.75 7.5H6.25C5.90505 7.5 5.625 7.78005 5.625 8.125V13.125",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 6.25006C1.87491 5.88201 2.03703 5.53263 2.31813 5.29506L6.69313 1.54506C7.15899 1.15132 7.84101 1.15132 8.30688 1.54506L12.6819 5.29506C12.963 5.53263 13.1251 5.88201 13.125 6.25006V11.8751C13.125 12.5649 12.5649 13.1251 11.875 13.1251H3.125C2.43511 13.1251 1.875 12.5649 1.875 11.8751V6.25006",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.fa9b043d31d1dff3f3bbc4afce093425.svg";
export { ForwardRef as ReactComponent };